(function () {
  'use strict';

  function initToolbar(toolbar) {
    if (toolbar.dataset.zwcTbInit) return;
    toolbar.dataset.zwcTbInit = '1';

    var sectionId = toolbar.getAttribute('data-zwc-section');
    var root = toolbar.closest('[data-zwc-root]') || document;
    var STORAGE_KEY_D = 'zwc-cols-d';
    var STORAGE_KEY_M = 'zwc-cols-m';
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var MOBILE_DEFAULT = toolbar.getAttribute('data-zwc-mobile-default-cols') || '2';

    /* Client-side sorts (no server round-trip). Values must match the
       "zwc-" options rendered in zwc-toolbar.liquid, and read the
       data-zwc-discount / data-zwc-rating attributes stamped on each
       [data-zwc-card] by zwc-product-card.liquid. */
    var CLIENT_SORTS = { 'zwc-discount': true, 'zwc-rating': true };

    function getGrid() { return root.querySelector('[data-zwc-grid]'); }
    function getGridWrap() { return root.querySelector('[data-zwc-grid-wrap]'); }
    function getSidebar() {
      return root.querySelector('[data-zwc-sidebar]') || document.querySelector('[data-zwc-sidebar]');
    }
    function isMobile() { return mqMobile.matches; }

    /* ---------- TOOLBAR HEIGHT SYNC ---------- */
    function syncToolbarHeight() {
      var h = toolbar.offsetHeight || 48;
      if (root.style) root.style.setProperty('--zwc-toolbar-h', h + 'px');
    }
    syncToolbarHeight();
    window.addEventListener('resize', syncToolbarHeight);
    window.addEventListener('load', syncToolbarHeight);
    setTimeout(syncToolbarHeight, 400);
    setTimeout(syncToolbarHeight, 1200);

    /* ---------- LAYOUT SWITCH (FLIP animation) ---------- */
    function activeSwitches() {
      var sel = isMobile() ? '[data-zwc-only="mobile"]' : '[data-zwc-only="desktop"]';
      return Array.prototype.slice.call(toolbar.querySelectorAll('.zwc-lswitch' + sel));
    }

    function applyCols(cols, animate) {
      var grid = getGrid();
      if (!grid) return;

      var cards = animate ? Array.prototype.slice.call(grid.querySelectorAll('.zwc-card')) : [];
      var first = [];
      if (animate) {
        cards.forEach(function (card) {
          var r = card.getBoundingClientRect();
          first.push({ left: r.left, top: r.top, width: r.width, height: r.height });
        });
      }

      grid.style.setProperty('--zwc-cols', cols);
      grid.setAttribute('data-zwc-cols', cols);

      activeSwitches().forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-zwc-cols') === String(cols));
      });

      try { localStorage.setItem(isMobile() ? STORAGE_KEY_M : STORAGE_KEY_D, cols); } catch (e) {}

      if (!animate) return;

      cards.forEach(function (card, i) {
        var f = first[i];
        if (!f) return;
        var r = card.getBoundingClientRect();
        var dx = f.left - r.left;
        var dy = f.top - r.top;
        var sx = f.width / r.width || 1;
        var sy = f.height / r.height || 1;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(sx - 1) < 0.01 && Math.abs(sy - 1) < 0.01) return;

        card.classList.remove('zwc-flipping');
        card.style.transformOrigin = 'top left';
        card.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';

        requestAnimationFrame(function () {
          card.classList.add('zwc-flipping');
          card.style.transform = '';
        });

        card.addEventListener('transitionend', function te() {
          card.classList.remove('zwc-flipping');
          card.style.transform = '';
          card.style.transformOrigin = '';
          card.removeEventListener('transitionend', te);
        });
      });
    }

    function defaultColsFor() {
      var stored, fallback;
      if (isMobile()) {
        try { stored = localStorage.getItem(STORAGE_KEY_M); } catch (e) {}
        fallback = MOBILE_DEFAULT;
      } else {
        try { stored = localStorage.getItem(STORAGE_KEY_D); } catch (e) {}
        fallback = (root.getAttribute ? root.getAttribute('data-default-cols') : null) || '2';
      }
      return stored || fallback;
    }

    function applyDefaultForViewport(animate) {
      applyCols(defaultColsFor(), !!animate);
    }

    applyDefaultForViewport(false);

    toolbar.querySelectorAll('.zwc-lswitch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyCols(btn.getAttribute('data-zwc-cols'), true);
      });
    });

    function handleViewportChange() { applyDefaultForViewport(false); }
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', handleViewportChange);
    else if (mqMobile.addListener) mqMobile.addListener(handleViewportChange);

    document.addEventListener('zwc:rerender', function () {
      applyDefaultForViewport(false);
      /* Grid + sort dropdown were replaced by the AJAX swap: re-apply the
         active client-side sort (order AND active-option marking). */
      var collectionRoot = toolbar.closest('[data-zwc-root]');
      var mode = collectionRoot ? collectionRoot._zwcClientSort : null;
      if (mode && CLIENT_SORTS[mode]) {
        markClientSortActive(mode);
        clientSortGrid(mode);
      }
    });

    /* ---------- CLIENT-SIDE SORT (discount / rating) ---------- */
    function clientSortGrid(mode) {
      var grid = getGrid();
      if (!grid) return;
      var wraps = Array.prototype.slice.call(grid.querySelectorAll('.zwc-card-wrap'));
      if (!wraps.length) return;

      function metric(wrap) {
        var card = wrap.querySelector('[data-zwc-card]');
        if (!card) return -1;
        if (mode === 'zwc-discount') {
          return parseFloat(card.getAttribute('data-zwc-discount')) || 0;
        }
        /* zwc-rating: raw rating, review count as a tiny tiebreaker so a
           4.8 with 200 reviews beats a 4.8 with 3 reviews. */
        var r = parseFloat(card.getAttribute('data-zwc-rating')) || 0;
        var c = parseFloat(card.getAttribute('data-zwc-rating-count')) || 0;
        return r + Math.min(c, 999) / 100000;
      }

      /* Random tiebreaker: products with EQUAL scores are shuffled among
         themselves each time the sort runs. Higher score still always
         ranks above lower score. */
      wraps
        .map(function (w) { return { w: w, m: metric(w), r: Math.random() }; })
        .sort(function (a, b) { return (b.m - a.m) || (a.r - b.r); })
        .forEach(function (item) { grid.appendChild(item.w); });
    }

    function markClientSortActive(mode) {
      var dropdown = toolbar.querySelector('[data-zwc-sort-dropdown]');
      if (!dropdown) return;
      var label = '';
      dropdown.querySelectorAll('[data-zwc-sort-value]').forEach(function (opt) {
        var isIt = opt.getAttribute('data-zwc-sort-value') === mode;
        opt.classList.toggle('is-active', isIt);
        opt.setAttribute('aria-selected', isIt ? 'true' : 'false');
        if (isIt) label = opt.textContent.trim();
      });
      var cur = dropdown.querySelector('[data-zwc-sort-current-label]');
      if (cur && label) cur.textContent = label;
    }

    /* ---------- SORT DROPDOWN ---------- */
    var sortWrap = toolbar.querySelector('[data-zwc-sort]');
    if (sortWrap) {
      var sortTrigger = sortWrap.querySelector('[data-zwc-sort-trigger]');
      var sortDropdown = sortWrap.querySelector('[data-zwc-sort-dropdown]');

      sortTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = sortWrap.classList.toggle('is-open');
        sortDropdown.hidden = !open;
        sortTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      sortWrap.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-zwc-sort-value]');
        if (!opt) return;
        navigateSort(opt.getAttribute('data-zwc-sort-value'));
        sortWrap.classList.remove('is-open');
        sortDropdown.hidden = true;
      });

      document.addEventListener('click', function (e) {
        if (!sortWrap.contains(e.target)) {
          sortWrap.classList.remove('is-open');
          sortDropdown.hidden = true;
        }
      });
    }

    /* ---------- SORT NAVIGATION (routes through zwc-collection.js) ----------
       Native Shopify sorts go through the collection file's shared AJAX
       pipeline via a `zwc:sort` event (preserving filters, re-binding
       everything through reinit()).
       "zwc-" sorts (Better Discount / Customer Rating) are handled
       entirely client-side: they reorder the rendered cards in the DOM
       and persist on root._zwcClientSort so they survive filter AJAX. */
    function navigateSort(sortValue) {
      var collectionRoot = toolbar.closest('[data-zwc-root]');

      if (CLIENT_SORTS[sortValue]) {
        if (collectionRoot) collectionRoot._zwcClientSort = sortValue;
        markClientSortActive(sortValue);
        clientSortGrid(sortValue);
        return;
      }

      /* Native sort chosen: clear any client sort, server order wins. */
      if (collectionRoot) collectionRoot._zwcClientSort = null;

      if (collectionRoot && typeof collectionRoot._zwcNavigate === 'function') {
        collectionRoot.dispatchEvent(new CustomEvent('zwc:sort', {
          detail: { sort: sortValue }
        }));
        return;
      }
      // Fallback (collection JS not present): hard navigate, preserving filters.
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }

    /* ---------- MOBILE FILTER DRAWER (left slide) ---------- */
    var drawer       = document.getElementById('zwc-drawer-' + sectionId);
    var openBtn      = toolbar.querySelector('[data-zwc-open]');
    var drawerBody   = drawer ? drawer.querySelector('[data-zwc-drawer-body]') : null;
    var drawerOverlay= drawer ? drawer.querySelector('[data-zwc-drawer-overlay]') : null;
    var drawerClose  = drawer ? drawer.querySelector('[data-zwc-drawer-close]') : null;

    var sidebarHomeParent = null;
    var sidebarHomeNext = null;

    function homeSidebarToDrawer() {
      var sidebar = getSidebar();
      if (!sidebar || !drawerBody) return false;
      if (sidebar.parentNode === drawerBody) return true;
      sidebarHomeParent = sidebar.parentNode;
      sidebarHomeNext = sidebar.nextSibling;
      drawerBody.appendChild(sidebar);
      return true;
    }

    function returnSidebarHome() {
      var sidebar = drawerBody ? drawerBody.querySelector('[data-zwc-sidebar]') : null;
      if (!sidebar || !sidebarHomeParent) return;
      if (sidebarHomeNext && sidebarHomeNext.parentNode === sidebarHomeParent) {
        sidebarHomeParent.insertBefore(sidebar, sidebarHomeNext);
      } else {
        sidebarHomeParent.appendChild(sidebar);
      }
      sidebarHomeParent = null;
      sidebarHomeNext = null;
    }

    function openDrawer() {
      if (!drawer) return;
      var moved = homeSidebarToDrawer();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
          document.body.classList.add('zwc-drawer-open');
        });
      });
      if (!moved) {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('zwc-drawer-open');
      }
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('zwc-drawer-open');
      setTimeout(returnSidebarHome, 340);
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('zwc:filters-applied', function () {
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    var mqDesktop = window.matchMedia('(min-width: 750px)');
    function handleMqDesktop(e) {
      if (e.matches && drawer && drawer.classList.contains('is-open')) closeDrawer();
    }
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', handleMqDesktop);
    else if (mqDesktop.addListener) mqDesktop.addListener(handleMqDesktop);

    window.addEventListener('popstate', function () { window.location.reload(); });
  }

  function boot() {
    document.querySelectorAll('[data-zwc-toolbar]').forEach(initToolbar);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();